import { render, staticRenderFns } from "./CModalFooter.vue?vue&type=template&id=81a89e46&"
import script from "./CModalFooter.vue?vue&type=script&lang=js&"
export * from "./CModalFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports